module.exports = __webpack_public_path__ + "static/media/sjzlBackground.4a3cec54.jpg";